export function getValue(obj, fields) {
    let value;
    fields = fields.split(',');
    if (fields.length === 1) {
        value = obj[fields[0]];
    } else {
        for (let i = 0, l = fields.length; i < l; i++) {
            value = obj[fields[i]];
            if (value) {
                break;
            }
        }
    }
    return value || '';
}
